<script setup lang="ts">

import { FiltersBar } from '@shared/ui/filters'
import { AppInput } from '@shared/ui/inputs'
import { BtnPrimary } from '@shared/ui/buttons'

import { useFiltersTeams } from '../../model/teams/filters-teams.hook'

defineOptions({
  name: 'FiltersTeams',
})

const {
  refSearch,
  canManage,
  isLoading,
  submitSearch,
  openCreateModal,
} = useFiltersTeams()
</script>

<template>
  <FiltersBar
    class="filters-teams"
    :loading="isLoading"
    :clearable="false"
    @click:submit="submitSearch"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        label="Search"
        placeholder="Team name"
      />
    </template>

    <template #end>
      <BtnPrimary
        v-if="canManage"
        text="Create team"
        color="emerald"
        element-width="auto"
        :disabled="isLoading"
        @click="openCreateModal"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersTeams.scss" />
